<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Contact</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <span>Contact</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <!-- contact info area start here -->
        <section class="bd-contact-info-area pt-120 pb-95">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <div class="bd-contact-info-wrap mb-30 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-contact-info">
                                <div class="bd-contact-info-content">
                                    <div class="bd-contact-info-icon cat-1">
                                        <a href="tel:0918955437089"><i class="flaticon-phone-call"></i></a>
                                    </div>
                                    <h6><a href="tel:0918955437089">9189554 37089</a></h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <div class="bd-contact-info-wrap mb-30 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".4s">
                            <div class="bd-contact-info">
                                <div class="bd-contact-info-content">
                                    <div class="bd-contact-info-icon cat-2">
                                        <a href="#"><i class="flaticon-location-pin"></i></a>
                                    </div>
                                    <h6><a href="#">Khemko Ka Mohalla, Near SBI Bank, Reengus Dist-Sikar (Raj) -
                                            332404</a>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <div class="bd-contact-info-wrap mb-30 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".5s">
                            <div class="bd-contact-info">
                                <div class="bd-contact-info-content">
                                    <div class="bd-contact-info-icon cat-1">
                                        <a href="mailto:contactus.vgps@vedantafoundation.org"><i
                                                class="flaticon-email"></i></a>
                                    </div>
                                    <h6><a
                                            href="mailto:contactus.vgps@vedantafoundation.org">contactus.vgps@vedantafoundation.org</a>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- contact info area end here-->

        <!-- contact area start here  -->
        <section class="bd-contact-area pb-60">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 mb-60 d-none">
                        <div class="bd-contact-form wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <h3 class="bd-contact-form-title mb-25">Contact Us Right Here</h3>
                            <form action="#">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="bd-contact-input mb-30">
                                            <label for="name">Name <sup><i
                                                        class="fa-solid fa-star-of-life"></i></sup></label>
                                            <input id="name" type="text">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="bd-contact-input mb-30">
                                            <label for="email">Email <sup><i
                                                        class="fa-solid fa-star-of-life"></i></sup></label>
                                            <input id="email" type="text">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="bd-contact-input mb-30">
                                            <label for="phone">Phone <sup><i
                                                        class="fa-solid fa-star-of-life"></i></sup></label>
                                            <input id="phone" type="text">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="bd-contact-input mb-30">
                                            <label for="subject">Programs<sup><i
                                                        class="fa-solid fa-star-of-life"></i></sup></label>
                                            <select name="subject" id="subject" class="bd-nice-select">
                                                <option>Select program</option>
                                                <option>Pre-Primary</option>
                                                <option>Primary</option>
                                                <option>Secondary</option>
                                                <option>Higher Secondary</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="bd-contact-input mb-20">
                                            <label for="textarea">Comments <sup><i
                                                        class="fa-solid fa-star-of-life"></i></sup></label>
                                            <textarea name="textarea" id="textarea"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mb-30">
                                        <div class="bd-contact-agree d-flex align-items-center">
                                            <input class="" type="checkbox" id="check-agree">
                                            <label class="check-label" for="check-agree">Accept Terms and
                                                Conditions</label>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="bd-contact-agree-btn">
                                            <button type="submit" class="bd-btn">
                                                <span class="bd-btn-inner">
                                                    <span class="bd-btn-normal">Send
                                                        now</span>
                                                    <span class="bd-btn-hover">Send
                                                        now</span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="col-xl-12 mb-60">
                        <div class="bd-contact-map wow fadeInRight" data-wow-duration="1s" data-wow-delay=".3s">
                            <iframe
                                src="https://www.google.com/maps/embed/v1/place?q=Vedanta+Gurukul+Public+Sr.+Sec.+School&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
                                style="border:0;" allowfullscreen="" loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- contact area end here  -->

    </main>
</template>
<script>
export default {
    name: "ContactView",
};
</script>
